import { sortBy } from 'lodash';
import { Component, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { UserService } from 'src/app/core/service/user.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { OrganizationService } from 'src/app/core/service/organization.service';
import { Organization } from 'src/app/core/model/organization';
import { MessageSubject, MessengerService } from 'src/app/core/service/messenger.service';

@Component({
  standalone: false,
  selector: 'app-select-organization',
  templateUrl: './select-organization.component.html',
  styleUrls: ['./select-organization.component.scss']
})
export class SelectOrganizationComponent 
{
  @ViewChild('selectButton') public selectButton: any;

  public dialogOpened = false;
  public activeOrganizations = [];
  public selectedOrganizationId: number;
  public roleSelectionPromise: Promise<string>;

  private userName: string;
  private currentOrganizationId: number;
  private resolve: any;

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private organizationService: OrganizationService,
    private messengerService: MessengerService,
    private messageHandlerService: MessageHandlerService) { }

  public execute(userName: string, currentOrganizationId: number, activeOrganizations: any): Promise<string>
  {
    this.userName = userName;
    this.currentOrganizationId = currentOrganizationId;
    this.selectedOrganizationId = currentOrganizationId;

    this.organizationService.getCachedOrganizations().subscribe({
      next: (data) =>
      {
        const organizationIds = activeOrganizations.map((x: any) => x.organizationId);
        this.activeOrganizations = sortBy(data.filter((x: Organization) => organizationIds.includes(x.id)), ['name']);
        this.dialogOpened = true;
        setTimeout(() =>
        {
          if (this.selectButton)
          {
            this.selectButton.nativeElement.focus();
          }
        });
      }
    });

    this.roleSelectionPromise = new Promise(resolve =>
    {
      this.resolve = resolve;
    });
    return this.roleSelectionPromise;
  }

  public close(): void
  {
    // If used from the header and hit close, it will not set automatically but just close the modal.
    if (this.authenticationService.isAuthenticated)
    {
      this.dialogOpened = false;
      this.resolve(null);
    }
    else
    {
      this.select();
    }
  }

  public select(): void
  {
    this.dialogOpened = false;
    // If selected role is different from authentication, update user role and continue process
    const organizationName = this.activeOrganizations.find((x: any) => x.id === this.selectedOrganizationId).name;
    if (this.currentOrganizationId !== this.selectedOrganizationId)
    {
      this.userService.updateUserActiveOrganization(this.userName, this.selectedOrganizationId).subscribe({
        next: () =>
        {
          this.resolve({ id: this.selectedOrganizationId, name: organizationName });
          this.messengerService.sendMessage(new MessageSubject('organization-changed', { id: this.selectedOrganizationId, name: organizationName }));
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
          this.resolve({ id: this.selectedOrganizationId, name: organizationName });
        }
      });
    }
    else
    {
      this.resolve({ id: this.selectedOrganizationId, name: organizationName });
    }
  }
}
